import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsBasicStep.AddPersonWizard.RoleStep', {
    director: 'Director',
    owner: 'Company owner (10%+ Shareholder)',
    directorWithOwnership: 'Director and company owner (10%+ Shareholder)',
    requiredField: 'Field is required',
    person: 'Person',
    personPlaceholder: 'Select a person...',
    requiresVerification: 'This {role} requires verification',
    inOrderToProceed:
        'In order to proceed with the onboarding you will need one of the directors to complete data verification.',
    directorShort: 'director',
    ownerShort: 'owner',
    firstName: 'First name',
    firstNamePlaceholder: 'Enter first name...',
    lastName: 'Last name',
    lastNamePlaceholder: 'Enter last name...',
    middleName: 'Middle name',
    middleNamePlaceholder: 'Enter middle name...',
    email: 'Email',
    emailPlaceholder: 'Enter email...',
    homeCountry: 'Home country',
    homeCountryPlaceholder: 'Select country...',
    ownershipPercentage: 'Ownership percentage',
    ownershipPercentagePlaceholder: 'Enter...',
});
